import { gql } from '@apollo/client';

export default gql`
  query getActions(
    $type: Int
    $active: Boolean
    $eventId: Int
    $contractId: String
    $procId: String
    $opId: String
    $reminderId: Int
    $start: Date
    $end: Date
  ) {
    getActions(
      type: $type
      active: $active
      eventId: $eventId
      contractId: $contractId
      procId: $procId
      opId: $opId
      reminderId: $reminderId
      start: $start
      end: $end
    ) {
      ok
      error
      data {
        _id
        branch
        autoNo
        indx
        type
        sendtime
        phone
        email
        user
        title
        body
        url
        sent
        active
        smsqty

        phones
        emails
        users
        transres

        reminderId
        eventId

        employeeId
        departmentId
        customerId
        resourseId
        projectId
        contractId
        procId
        opId
        opType
        opDocNo

        data
        info

        timeunit
        timerelate
        qty
        address

        userId
        createdAt
        updatedAt
      }
    }
  }
`;
